export const PROJECT_ID = "insightlist-prod"
export const DOMAIN = PROJECT_ID + ".web.app"
export const ENV = {
  "PROJECT_ID": PROJECT_ID,
  "API_KEY": "AIzaSyBz10eZ31VB8gVaB1Y_qo018p6lQBiXiHc",
  "API_BASE_URL": "https://us-west2-"+PROJECT_ID+".cloudfunctions.net",
  "DOMAIN": DOMAIN,
  "ORIGIN_URL": "https://"+DOMAIN,
  "LP_URL": "http://insightlist.com"
}